import * as React from 'react';
type Props = {
  className?: string;
};
export function NoPotatoes({ className }: Props) {
  return (
    <svg
      viewBox="0 0 61 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-NoPotatoes"
      className={className}
    >
      <g clipPath="url(#clip0_146_1065)">
        <path
          d="M11.7852 52.4533L16.1777 47.1028"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M1.08398 29.9999C1.08398 24.182 2.80926 18.4948 6.04152 13.6574C9.27378 8.81994 13.8677 5.04961 19.2428 2.82319C24.6179 0.596769 30.5324 0.0142659 36.2385 1.14928C41.9446 2.2843 47.1861 5.08591 51.2999 9.19979C55.4138 13.3137 58.2156 18.5551 59.3506 24.2612C60.4856 29.9673 59.9031 35.8819 57.6767 41.2569C55.4503 46.632 51.6798 51.2261 46.8424 54.4584C42.005 57.6906 36.3177 59.4159 30.4998 59.4159C22.6982 59.4159 15.2162 56.3166 9.69964 50.8001C4.18309 45.2835 1.08398 37.8015 1.08398 29.9999"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M44.8809 12.7921L49.215 7.58179"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M30.4883 30.0701L37.0771 22.1846"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M33.1985 30.4557C33.1985 30.4557 17.7547 27.3482 12.264 37.0094C12.264 37.0094 7.52088 44.965 22.0419 49.0537C22.0419 49.0537 33.5255 51.9977 40.0675 48.5515C41.4442 47.9262 42.624 46.9364 43.4789 45.6892C44.3288 44.4385 44.8252 42.9815 44.9158 41.472C45.0443 36.9509 39.6938 31.8809 33.1985 30.4557Z"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M16.2358 41.7874C16.6324 41.3694 17.132 41.0632 17.6844 40.8995C18.4953 40.6843 19.3398 40.6248 20.1729 40.7242C20.946 40.8411 21.7276 40.8919 22.5093 40.8761C22.7234 40.8877 22.9376 40.8877 23.1516 40.8761"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M33.3388 41.4719L27.0186 38.8317"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M36.0371 37.3831L36.7031 35.0467"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M28.8296 45.5024L30.7106 47.8388"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M25.2432 33.9486L22.4746 35.2102"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M41.2359 40.9463C41.2031 41.5309 41.0135 42.0959 40.6869 42.5818C40.1999 43.2675 39.5946 43.8609 38.8994 44.3342C38.2385 44.7312 37.6133 45.1845 37.0304 45.6892C36.8202 45.8878 36.6681 46.0397 36.563 46.1565"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M41.0258 11.4135C41.0258 11.4135 29.2501 9.708 23.8179 14.8482C23.8179 14.8482 19.4488 19.0887 28.8647 21.4719C28.8647 21.4719 36.2946 23.201 41.9488 21.3785C41.9488 21.3785 45.9325 20.3738 47.6031 17.4999C49.0166 15.0116 46.0492 12.1962 41.0258 11.4135Z"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M26.1895 17.8621C26.4103 17.6363 26.683 17.4679 26.9838 17.3714C27.4332 17.253 27.9012 17.2213 28.3625 17.278C28.7797 17.344 29.2015 17.3752 29.624 17.3714H29.9862"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M38.1399 17.0562L34.6353 15.5959"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M40.3599 14.6846L40.7338 13.3879"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M32.9414 18.6799L33.981 19.9767"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M32.7777 13.3294L31.2476 14.0186"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
        <path
          d="M43.4792 16.4953C43.4534 16.8102 43.3533 17.1145 43.1871 17.3832C42.9193 17.762 42.5823 18.0871 42.194 18.3412C41.8224 18.5636 41.4707 18.8177 41.1427 19.1006L40.8975 19.3458"
          stroke="currentColor"
          strokeMiterlimit={10}
        />
      </g>
      <defs>
        <clipPath id="clip0_146_1065">
          <rect
            width={60}
            height={60}
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
